/* eslint-disable max-classes-per-file */

import type { SlotName } from "../config/platforms/types";
import type { AdNode } from "./AdNode";
import type { AdNodeManager } from "./AdNodeManager";

export class AdNodeComponent extends HTMLElement {
  static readonly ELEMENT_NAME = "fandom-ad";

  private readonly adNodeManager: AdNodeManager;
  private adNode: AdNode | undefined;

  constructor(adNodeManager: AdNodeManager) {
    super();
    this.adNodeManager = adNodeManager;
  }

  connectedCallback() {
    if (!this.adNode) {
      this.createAdNode();
    }
  }

  disconnectedCallback() {
    this.adNodeManager.removeAdNode(this.adNode!);
    this.adNode = undefined;
  }

  private createAdNode() {
    this.adNode = this.adNodeManager.createAdNode(this.id as SlotName);
    if (!this.adNode) {
      throw new Error(
        `AdNode for element with id[${this.id}] could not be created.`,
      );
    }
  }
}

export function registerAdNodeComponent(adNodeManager: AdNodeManager) {
  if (!customElements.get(AdNodeComponent.ELEMENT_NAME)) {
    customElements.define(
      AdNodeComponent.ELEMENT_NAME,
      class extends AdNodeComponent {
        constructor() {
          super(adNodeManager);
        }
      },
    );
  }
}
